export const RENTAL_OPERATOR_PUBLISH_REVIEW_SUCCESS = "RENTAL_OPERATOR_PUBLISH_REVIEW_SUCCESS";
export const RENTAL_OPERATOR_PUBLISH_REVIEW_ERROR = "RENTAL_OPERATOR_PUBLISH_REVIEW_ERROR";
export const RENTAL_OPERATOR_PUBLISH_REVIEW_START = "RENTAL_OPERATOR_PUBLISH_REVIEW_START";

export const RENTAL_OPERATOR_DECLINED_SUCCESS = "RENTAL_OPERATOR_DECLINED_SUCCESS";
export const RENTAL_OPERATOR_DECLINED_ERROR = "RENTAL_OPERATOR_DECLINED_ERROR";
export const RENTAL_OPERATOR_DECLINED_START = "RENTAL_OPERATOR_DECLINEDL_START";